export class FileFunction {

    static getBase64(file: File): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as any);
            reader.onerror = error => reject(error);
        });
    }

    static is2MB(file: File): boolean {
        return file.size <= 1024 * 1024 * 2;//2mb
    }

    static is20MB(file: File): boolean {
        return file.size <= 1024 * 1024 * 20;
    }

    static isImage(file: File): boolean {
        if (file && file['type'] == 'image/svg+xml') return false;
        return file && file['type'].split('/')[0] == 'image';
    }

    static isImageOrPdf(file: File): boolean {
        return this.isImage(file) || file['type'] == 'application/pdf';
    }

    static isVideo(file: File): boolean {
        if (!file) return false;
        const allowedFormats = ['video/mp4', 'video/flv', 'video/mov'];
        return allowedFormats.includes(file.type);
    }
    

    static isPdf(file: File): boolean {
        return file['type'] == 'application/pdf';
    }

    static base64ToBlob(base64: string, contentType: string = '', sliceSize: number = 512): Blob {
        const byteCharacters = atob(base64.split(',')[1]);
        const byteArrays = [];
    
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
    
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
    
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
    
        return new Blob(byteArrays, { type: contentType });
    }
}